import { Component } from '@angular/core';
import {provideRouter, RouterModule, RouterOutlet} from '@angular/router';
import {environment} from "../environments/environment";
import {AuthModule} from "./auth/auth.module";
import {AuthService} from "../services/auth.service";
import {HttpClientModule} from "@angular/common/http";
import {DashboardModule} from "./dashboard/dashboard.module";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    AuthModule,
    DashboardModule,
    HttpClientModule,
  ],
  providers: [
    AuthService
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = environment.title;
}
